import { IRectangle, List } from '@fluentui/react';
import { PhoneModel } from '../../../home/models/ContactInfo';
import PhoneItemView from './PhoneItemView';

type PhoneGridProps = {
    phones: PhoneModel[];
    onEdit: (phone: PhoneModel) => void;
    onDelete: (phone: PhoneModel) => void;
}

export default function PhoneGridView({ phones, onEdit, onDelete }: PhoneGridProps) {
    var columnCount: number = 0;

    const getItemCountForPage = (itemIndex?: number, surfaceRect?: IRectangle): number => {
        if (itemIndex === 0) {
            if (surfaceRect != null && surfaceRect.width < 700) columnCount = 1;
            else if (surfaceRect != null && surfaceRect.width < 1050) columnCount = 2;
            else columnCount = 3;
        }

        return phones.length;
    }

    const onRenderCell = (phone?: PhoneModel, index?: number, isScrolling?: boolean) => {
        const width = (100 / columnCount) + '%';
        const hPadding = columnCount === 1 ? " ph-10" : "";
        const vPadding = columnCount === 1 ? " pv-10" : " pv-20";

        if (phone == null) return <>empty</>;

        return <div
            key={phone.id + "-wrapper"}
            className={"list-grid-tile" + vPadding + hPadding}
            style={{ width: width, height: "auto" }}
            data-is-focusable={true}
        >
            <PhoneItemView
                key={phone.id}
                phone={phone}
                onEdit={onEdit}
                onDelete={onDelete}
            />
        </div>;
    }

    return <div className="ml--20 mr--20">
        <List
            items={phones}
            onRenderCell={onRenderCell}
            getItemCountForPage={getItemCountForPage}
        />
    </div>;
}